import React, { useState } from 'react';
import { Stack, Text, Link, IconButton } from '@fluentui/react';
import IvicosStrings from 'kits/language/stringKit';
import { renderFavicon } from '../../../URL/URL.utils';

const URLInfo: React.FC<{ type: string; content: any }> = ({ type, content }) => {
    const [failedFavicons, setFailedFavicons] = useState<Set<string>>(new Set());
    const handleFaviconError = (faviconUrl: string) => {
        setFailedFavicons((prev) => new Set(prev).add(faviconUrl));
    };

    if (type !== 'urls') return null;
    const { links } = content || {};
    if (!links || links.length === 0) return null;

    return (
        <Stack
            tokens={{ childrenGap: 16 }}
            styles={{
                root: { width: '100%', minWidth: 500, backgroundColor: '#F0F8FF', padding: 40, borderRadius: 10, maxHeight: 700, overflowY: 'auto' }
            }}
        >
            <Text variant="xLarge" style={{ fontWeight: 'bold', marginBottom: 20 }}>
                {links.length === 1
                    ? IvicosStrings.personalMeetingCornerStrings.url.recommendedLink
                    : IvicosStrings.personalMeetingCornerStrings.url.recommendedLinks}
            </Text>
            <Stack tokens={{ childrenGap: 12 }}>
                {links.map((link) => (
                    <Stack
                        key={link.id}
                        horizontal
                        tokens={{ childrenGap: 12 }}
                        verticalAlign="center"
                        style={{
                            padding: '16px',
                            border: '1px solid #e0e0e0',
                            borderRadius: '8px',
                            backgroundColor: '#fff',
                            cursor: 'pointer'
                        }}
                        onClick={() => window.open(link.url, '_blank')}
                    >
                        {renderFavicon({
                            favicon: link.favicon,
                            failedFavicons,
                            onFaviconError: handleFaviconError,
                            size: 'large'
                        })}
                        <Stack style={{ flex: 1 }}>
                            <Text variant="large" style={{ fontWeight: 600 }}>
                                {link.title}
                            </Text>
                            {link.description && (
                                <Text variant="medium" style={{ color: '#666', marginTop: 4 }}>
                                    {link.description}
                                </Text>
                            )}
                            <Text variant="small" style={{ color: '#999', marginTop: 4 }}>
                                {link.siteName || new URL(link.url).hostname}
                            </Text>
                        </Stack>
                        <IconButton iconProps={{ iconName: 'OpenInNewWindow' }} title={IvicosStrings.personalMeetingCornerStrings.url.openLink} />
                    </Stack>
                ))}
            </Stack>
        </Stack>
    );
};

export default URLInfo;
